import Vue from 'vue'
import Vuex from 'vuex'
import Meta from 'vue-meta'
import ClientOnly from 'vue-client-only'
import NoSsr from 'vue-no-ssr'
import { createRouter } from './router.js'
import NuxtChild from './components/nuxt-child.js'
import NuxtError from '../../../layouts/error.vue'
import Nuxt from './components/nuxt.js'
import App from './App.js'
import { setContext, getLocation, getRouteData, normalizeError } from './utils'
import { createStore } from './store.js'

/* Plugins */

import nuxt_plugin_plugin_b7b91190 from 'nuxt_plugin_plugin_b7b91190' // Source: ./components/plugin.js (mode: 'all')
import nuxt_plugin_plugin_2da2b9d3 from 'nuxt_plugin_plugin_2da2b9d3' // Source: ./matomo/plugin.js (mode: 'client')
import nuxt_plugin_vsanitize_64ee6cac from 'nuxt_plugin_vsanitize_64ee6cac' // Source: ./v-sanitize.js (mode: 'all')
import nuxt_plugin_cookieuniversalnuxt_51a3f9f6 from 'nuxt_plugin_cookieuniversalnuxt_51a3f9f6' // Source: ./cookie-universal-nuxt.js (mode: 'all')
import nuxt_plugin_httpserver_2f410e8a from 'nuxt_plugin_httpserver_2f410e8a' // Source: ./http.server.js (mode: 'server')
import nuxt_plugin_http_1af25a42 from 'nuxt_plugin_http_1af25a42' // Source: ./http.js (mode: 'all')
import nuxt_plugin_dayjsplugin_f329e262 from 'nuxt_plugin_dayjsplugin_f329e262' // Source: ./dayjs-plugin.js (mode: 'all')
import nuxt_plugin_pluginutils_273144a6 from 'nuxt_plugin_pluginutils_273144a6' // Source: ./nuxt-i18n/plugin.utils.js (mode: 'all')
import nuxt_plugin_pluginrouting_260733b8 from 'nuxt_plugin_pluginrouting_260733b8' // Source: ./nuxt-i18n/plugin.routing.js (mode: 'all')
import nuxt_plugin_pluginmain_a945da92 from 'nuxt_plugin_pluginmain_a945da92' // Source: ./nuxt-i18n/plugin.main.js (mode: 'all')
import nuxt_plugin_toast_0d75fa06 from 'nuxt_plugin_toast_0d75fa06' // Source: ./toast.js (mode: 'client')
import nuxt_plugin_workbox_86de602c from 'nuxt_plugin_workbox_86de602c' // Source: ./workbox.js (mode: 'client')
import nuxt_plugin_metaplugin_6b8ee606 from 'nuxt_plugin_metaplugin_6b8ee606' // Source: ./pwa/meta.plugin.js (mode: 'all')
import nuxt_plugin_iconplugin_623f9b1e from 'nuxt_plugin_iconplugin_623f9b1e' // Source: ./pwa/icon.plugin.js (mode: 'all')
import nuxt_plugin_axios_2d14b64e from 'nuxt_plugin_axios_2d14b64e' // Source: ./axios.js (mode: 'all')
import nuxt_plugin_libplugin239dbf6a_1600e037 from 'nuxt_plugin_libplugin239dbf6a_1600e037' // Source: ./lib.plugin.239dbf6a.js (mode: 'all')
import nuxt_plugin_amplify_900d1ace from 'nuxt_plugin_amplify_900d1ace' // Source: ../../../plugins/amplify.js (mode: 'all')
import nuxt_plugin_graphcms_3ef315a6 from 'nuxt_plugin_graphcms_3ef315a6' // Source: ../../../plugins/graphcms.js (mode: 'all')
import nuxt_plugin_helpers_1c816d70 from 'nuxt_plugin_helpers_1c816d70' // Source: ../../../plugins/helpers.js (mode: 'all')
import nuxt_plugin_vueshortkey_7ae76292 from 'nuxt_plugin_vueshortkey_7ae76292' // Source: ../../../plugins/vue-shortkey.js (mode: 'client')
import nuxt_plugin_forumApi_7bc36ce8 from 'nuxt_plugin_forumApi_7bc36ce8' // Source: ../../../plugins/forumApi.js (mode: 'all')
import nuxt_plugin_index_e21eb744 from 'nuxt_plugin_index_e21eb744' // Source: ../../../plugins/localeResolver/index.js (mode: 'all')
import nuxt_plugin_fbApi_0c3792ef from 'nuxt_plugin_fbApi_0c3792ef' // Source: ../../../plugins/fbApi.js (mode: 'all')
import nuxt_plugin_vueplyr_a4e20576 from 'nuxt_plugin_vueplyr_a4e20576' // Source: ../../../plugins/vue-plyr.js (mode: 'client')
import nuxt_plugin_hcaptcha_03f36b22 from 'nuxt_plugin_hcaptcha_03f36b22' // Source: ../../../plugins/hcaptcha.js (mode: 'client')
import nuxt_plugin_crmApi_03db4a65 from 'nuxt_plugin_crmApi_03db4a65' // Source: ../../../plugins/crmApi.js (mode: 'all')
import nuxt_plugin_auth_ab501dbc from 'nuxt_plugin_auth_ab501dbc' // Source: ./auth.js (mode: 'all')
import nuxt_plugin_auth_7f7561ce from 'nuxt_plugin_auth_7f7561ce' // Source: ../../../plugins/auth.js (mode: 'all')

// Component: <ClientOnly>
Vue.component(ClientOnly.name, ClientOnly)

// TODO: Remove in Nuxt 3: <NoSsr>
Vue.component(NoSsr.name, {
  ...NoSsr,
  render (h, ctx) {
    if (process.client && !NoSsr._warned) {
      NoSsr._warned = true

      console.warn('<no-ssr> has been deprecated and will be removed in Nuxt 3, please use <client-only> instead')
    }
    return NoSsr.render(h, ctx)
  }
})

// Component: <NuxtChild>
Vue.component(NuxtChild.name, NuxtChild)
Vue.component('NChild', NuxtChild)

// Component NuxtLink is imported in server.js or client.js

// Component: <Nuxt>
Vue.component(Nuxt.name, Nuxt)

Object.defineProperty(Vue.prototype, '$nuxt', {
  get() {
    const globalNuxt = this.$root.$options.$nuxt
    if (process.client && !globalNuxt && typeof window !== 'undefined') {
      return window.$nuxt
    }
    return globalNuxt
  },
  configurable: true
})

Vue.use(Meta, {"keyName":"head","attribute":"data-n-head","ssrAttribute":"data-n-head-ssr","tagIDKeyName":"hid"})

const defaultTransition = {"name":"page","mode":"out-in","appear":true,"appearClass":"appear","appearActiveClass":"appear-active","appearToClass":"appear-to"}

const originalRegisterModule = Vuex.Store.prototype.registerModule

function registerModule (path, rawModule, options = {}) {
  const preserveState = process.client && (
    Array.isArray(path)
      ? !!path.reduce((namespacedState, path) => namespacedState && namespacedState[path], this.state)
      : path in this.state
  )
  return originalRegisterModule.call(this, path, rawModule, { preserveState, ...options })
}

async function createApp(ssrContext, config = {}) {
  const router = await createRouter(ssrContext, config)

  const store = createStore(ssrContext)
  // Add this.$router into store actions/mutations
  store.$router = router

  // Create Root instance

  // here we inject the router and store to all child components,
  // making them available everywhere as `this.$router` and `this.$store`.
  const app = {
    head: {"meta":[{"hid":"charset","charset":"utf-8"},{"name":"viewport","content":"width=device-width, initial-scale=1"},{"name":"format-detection","content":"telephone=no"},{"name":"author","content":"MED-EL"},{"hid":"og:image","property":"og:image","content":"https:\u002F\u002Fhearpeers.medel.com\u002Fopen-graph-preview.png"},{"hid":"description","name":"description","content":"Become part of our international hearpeers community and find out everything you need to know about cochlear implants and other hearing solutions."},{"hid":"og:description","name":"og:description","property":"og:description","content":"Become part of our international hearpeers community and find out everything you need to know about cochlear implants and other hearing solutions."}],"link":[{"rel":"icon","type":"image\u002Fx-icon","href":"\u002Ffavicon.ico"},{"rel":"preconnect","href":"https:\u002F\u002Fapi-eu-central-1.graphcms.com"},{"rel":"preconnect","href":"https:\u002F\u002Fauth.login.medel.com\u002F"}],"style":[],"script":[{"src":"https:\u002F\u002Fanalytics.explore-life.com\u002Fmatomo.js","body":true,"defer":true,"async":true}]},

    store,
    router,
    nuxt: {
      defaultTransition,
      transitions: [defaultTransition],
      setTransitions (transitions) {
        if (!Array.isArray(transitions)) {
          transitions = [transitions]
        }
        transitions = transitions.map((transition) => {
          if (!transition) {
            transition = defaultTransition
          } else if (typeof transition === 'string') {
            transition = Object.assign({}, defaultTransition, { name: transition })
          } else {
            transition = Object.assign({}, defaultTransition, transition)
          }
          return transition
        })
        this.$options.nuxt.transitions = transitions
        return transitions
      },

      err: null,
      dateErr: null,
      error (err) {
        err = err || null
        app.context._errored = Boolean(err)
        err = err ? normalizeError(err) : null
        let nuxt = app.nuxt // to work with @vue/composition-api, see https://github.com/nuxt/nuxt.js/issues/6517#issuecomment-573280207
        if (this) {
          nuxt = this.nuxt || this.$options.nuxt
        }
        nuxt.dateErr = Date.now()
        nuxt.err = err
        // Used in src/server.js
        if (ssrContext) {
          ssrContext.nuxt.error = err
        }
        return err
      }
    },
    ...App
  }

  // Make app available into store via this.app
  store.app = app

  const next = ssrContext ? ssrContext.next : location => app.router.push(location)
  // Resolve route
  let route
  if (ssrContext) {
    route = router.resolve(ssrContext.url).route
  } else {
    const path = getLocation(router.options.base, router.options.mode)
    route = router.resolve(path).route
  }

  // Set context to app.context
  await setContext(app, {
    store,
    route,
    next,
    error: app.nuxt.error.bind(app),
    payload: ssrContext ? ssrContext.payload : undefined,
    req: ssrContext ? ssrContext.req : undefined,
    res: ssrContext ? ssrContext.res : undefined,
    beforeRenderFns: ssrContext ? ssrContext.beforeRenderFns : undefined,
    ssrContext
  })

  function inject(key, value) {
    if (!key) {
      throw new Error('inject(key, value) has no key provided')
    }
    if (value === undefined) {
      throw new Error(`inject('${key}', value) has no value provided`)
    }

    key = '$' + key
    // Add into app
    app[key] = value
    // Add into context
    if (!app.context[key]) {
      app.context[key] = value
    }

    // Add into store
    store[key] = app[key]

    // Check if plugin not already installed
    const installKey = '__nuxt_' + key + '_installed__'
    if (Vue[installKey]) {
      return
    }
    Vue[installKey] = true
    // Call Vue.use() to install the plugin into vm
    Vue.use(() => {
      if (!Object.prototype.hasOwnProperty.call(Vue.prototype, key)) {
        Object.defineProperty(Vue.prototype, key, {
          get () {
            return this.$root.$options[key]
          }
        })
      }
    })
  }

  // Inject runtime config as $config
  inject('config', config)

  if (process.client) {
    // Replace store state before plugins execution
    if (window.__NUXT__ && window.__NUXT__.state) {
      store.replaceState(window.__NUXT__.state)
    }
  }

  // Add enablePreview(previewData = {}) in context for plugins
  if (process.static && process.client) {
    app.context.enablePreview = function (previewData = {}) {
      app.previewData = Object.assign({}, previewData)
      inject('preview', previewData)
    }
  }
  // Plugin execution

  if (typeof nuxt_plugin_plugin_b7b91190 === 'function') {
    await nuxt_plugin_plugin_b7b91190(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_plugin_2da2b9d3 === 'function') {
    await nuxt_plugin_plugin_2da2b9d3(app.context, inject)
  }

  if (typeof nuxt_plugin_vsanitize_64ee6cac === 'function') {
    await nuxt_plugin_vsanitize_64ee6cac(app.context, inject)
  }

  if (typeof nuxt_plugin_cookieuniversalnuxt_51a3f9f6 === 'function') {
    await nuxt_plugin_cookieuniversalnuxt_51a3f9f6(app.context, inject)
  }

  if (process.server && typeof nuxt_plugin_httpserver_2f410e8a === 'function') {
    await nuxt_plugin_httpserver_2f410e8a(app.context, inject)
  }

  if (typeof nuxt_plugin_http_1af25a42 === 'function') {
    await nuxt_plugin_http_1af25a42(app.context, inject)
  }

  if (typeof nuxt_plugin_dayjsplugin_f329e262 === 'function') {
    await nuxt_plugin_dayjsplugin_f329e262(app.context, inject)
  }

  if (typeof nuxt_plugin_pluginutils_273144a6 === 'function') {
    await nuxt_plugin_pluginutils_273144a6(app.context, inject)
  }

  if (typeof nuxt_plugin_pluginrouting_260733b8 === 'function') {
    await nuxt_plugin_pluginrouting_260733b8(app.context, inject)
  }

  if (typeof nuxt_plugin_pluginmain_a945da92 === 'function') {
    await nuxt_plugin_pluginmain_a945da92(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_toast_0d75fa06 === 'function') {
    await nuxt_plugin_toast_0d75fa06(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_workbox_86de602c === 'function') {
    await nuxt_plugin_workbox_86de602c(app.context, inject)
  }

  if (typeof nuxt_plugin_metaplugin_6b8ee606 === 'function') {
    await nuxt_plugin_metaplugin_6b8ee606(app.context, inject)
  }

  if (typeof nuxt_plugin_iconplugin_623f9b1e === 'function') {
    await nuxt_plugin_iconplugin_623f9b1e(app.context, inject)
  }

  if (typeof nuxt_plugin_axios_2d14b64e === 'function') {
    await nuxt_plugin_axios_2d14b64e(app.context, inject)
  }

  if (typeof nuxt_plugin_libplugin239dbf6a_1600e037 === 'function') {
    await nuxt_plugin_libplugin239dbf6a_1600e037(app.context, inject)
  }

  if (typeof nuxt_plugin_amplify_900d1ace === 'function') {
    await nuxt_plugin_amplify_900d1ace(app.context, inject)
  }

  if (typeof nuxt_plugin_graphcms_3ef315a6 === 'function') {
    await nuxt_plugin_graphcms_3ef315a6(app.context, inject)
  }

  if (typeof nuxt_plugin_helpers_1c816d70 === 'function') {
    await nuxt_plugin_helpers_1c816d70(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_vueshortkey_7ae76292 === 'function') {
    await nuxt_plugin_vueshortkey_7ae76292(app.context, inject)
  }

  if (typeof nuxt_plugin_forumApi_7bc36ce8 === 'function') {
    await nuxt_plugin_forumApi_7bc36ce8(app.context, inject)
  }

  if (typeof nuxt_plugin_index_e21eb744 === 'function') {
    await nuxt_plugin_index_e21eb744(app.context, inject)
  }

  if (typeof nuxt_plugin_fbApi_0c3792ef === 'function') {
    await nuxt_plugin_fbApi_0c3792ef(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_vueplyr_a4e20576 === 'function') {
    await nuxt_plugin_vueplyr_a4e20576(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_hcaptcha_03f36b22 === 'function') {
    await nuxt_plugin_hcaptcha_03f36b22(app.context, inject)
  }

  if (typeof nuxt_plugin_crmApi_03db4a65 === 'function') {
    await nuxt_plugin_crmApi_03db4a65(app.context, inject)
  }

  if (typeof nuxt_plugin_auth_ab501dbc === 'function') {
    await nuxt_plugin_auth_ab501dbc(app.context, inject)
  }

  if (typeof nuxt_plugin_auth_7f7561ce === 'function') {
    await nuxt_plugin_auth_7f7561ce(app.context, inject)
  }

  // Lock enablePreview in context
  if (process.static && process.client) {
    app.context.enablePreview = function () {
      console.warn('You cannot call enablePreview() outside a plugin.')
    }
  }

  // Wait for async component to be resolved first
  await new Promise((resolve, reject) => {
    // Ignore 404s rather than blindly replacing URL in browser
    if (process.client) {
      const { route } = router.resolve(app.context.route.fullPath)
      if (!route.matched.length) {
        return resolve()
      }
    }
    router.replace(app.context.route.fullPath, resolve, (err) => {
      // https://github.com/vuejs/vue-router/blob/v3.4.3/src/util/errors.js
      if (!err._isRouter) return reject(err)
      if (err.type !== 2 /* NavigationFailureType.redirected */) return resolve()

      // navigated to a different route in router guard
      const unregister = router.afterEach(async (to, from) => {
        if (process.server && ssrContext && ssrContext.url) {
          ssrContext.url = to.fullPath
        }
        app.context.route = await getRouteData(to)
        app.context.params = to.params || {}
        app.context.query = to.query || {}
        unregister()
        resolve()
      })
    })
  })

  return {
    store,
    app,
    router
  }
}

export { createApp, NuxtError }
